var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 35,
    viewBox: "0 0 17 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50059 17.5C10.3784 17.5 11.9006 15.933 11.9006 14C11.9006 12.067 10.3784 10.5 8.50059 10.5C6.62282 10.5 5.10059 12.067 5.10059 14C5.10059 15.933 6.62282 17.5 8.50059 17.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9979 34.8265L16.5971 31.7513C16.5932 31.7192 16.586 31.6876 16.5755 31.6573L9.04763 12.0848L5.40389 2.56379C5.39427 2.53595 5.38075 2.50991 5.36382 2.48657L3.65293 0.0593154C3.61402 0.00512119 3.54688 -0.0145075 3.48828 0.0111764C3.42968 0.0368604 3.39374 0.101663 3.40015 0.170103L3.80398 3.2453C3.80643 3.27662 3.81372 3.30727 3.82556 3.33594L6.36261 10.0067L14.9941 32.4328C15.0055 32.4604 15.02 32.4863 15.0373 32.51L16.7482 34.9373C16.7856 34.9938 16.8537 35.0151 16.913 34.9888C16.9723 34.9625 17.0074 34.8954 16.9979 34.8265Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.8586L0.401225 31.7809C0.405146 31.7488 0.412393 31.7172 0.42283 31.6868L7.94426 12.0982L11.5923 2.56931C11.602 2.54145 11.6155 2.51538 11.6324 2.49203L13.3485 0.0627678C13.386 0.00617365 13.4541 -0.0151394 13.5135 0.0111873C13.5729 0.037514 13.608 0.104642 13.5985 0.173647L13.1972 3.25138C13.1923 3.28257 13.184 3.31302 13.1725 3.3421L10.6201 10.0184L1.97835 32.463C1.96694 32.4906 1.95242 32.5165 1.93514 32.5403L0.222217 34.9695C0.181461 35.003 0.127129 35.0094 0.080724 34.9862C0.0343191 34.9631 0.00332175 34.9141 0 34.8586Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogo);
export default __webpack_public_path__ + "static/media/xLogo.b156948fe2b278b4a9a6641788a5ca21.svg";
export { ForwardRef as ReactComponent };